import {Capacitor} from "@capacitor/core";
import {getAuth, indexedDBLocalPersistence, initializeAuth} from "firebase/auth";
import {getApp} from "firebase/app";
import {FirebaseAuthentication} from "@capacitor-firebase/authentication";

let auth;
export const initialiseFirebaseAuth = () => {
    if (Capacitor.isNativePlatform()) {
        auth = initializeAuth(getApp(), {
            persistence: indexedDBLocalPersistence,
        });
    } else {
        auth = getAuth();
    }
};

const signInWithGoogle = async () => {
  const result = await FirebaseAuthentication.signInWithGoogle();
  return result.user;
};

const signInWithEmailAndPassword = async () => {
    const result = await FirebaseAuthentication.signInWithEmailAndPassword({
        email: 'mail@example.com',
        password: '1234',
    });
    return result.user;
};

const signOut = async () => {
    await FirebaseAuthentication.signOut();
};

export {
    auth,
    signInWithGoogle,
    signInWithEmailAndPassword,
    signOut,
}